module.exports = __webpack_public_path__ + "img/392e3a52-7888-41a3-9384-bf48f0f699e6.4d1bd1d7.jpg";